import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData,getKCISData} from '../../services/index';
import { message,Rate,Modal,Button   } from 'antd';
import { Bar } from 'react-chartjs-2';
import "../../assets/css/app-css.css";


class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			total_school: 0,
			value: '',
			aToken: '',
			fees_modal: false,
			modal_title:'',
			modal_value:'',
			program_id:'',
			division:'',
			child_data: [],
			graph_data: [],
			mobile_data: [],
			program_list: [],
			division_list: [],
			theme_list: [],
			academic_year_: [],
			academic_year: '',
			theme_id: '',
		}
	}
	
	

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			const params = new Proxy(new URLSearchParams(window.location.search), {
			    get: (searchParams, prop) => searchParams.get(prop),
			 });
			if(params.t!=null && params.s!=null){
				let token = params.t;
				let erp_id = params.s;
				var app = {token:token,erp_id:erp_id}
				var new_id = erp_id.split('_');
				getKCISData('auth/verify_token',app).then((result) => {
					let responseJson = result;
					if(responseJson){
						if(result['status'] == 200){
							localStorage.setItem('schoolData',JSON.stringify(responseJson));
							localStorage.setItem("app_token",params.t);
							var erp_id = result['data'][0]['erp_id'];
							var erp_type = erp_id.split('_');
							localStorage.setItem("erp_id",erp_id);
							localStorage.setItem("erp_type",erp_type[0]);
							window.location.reload(false);
						}
					}
				});
			}
			//localStorage.setItem("schoolData",'');
			//localStorage.clear();
			//window.location.href = '/login';
		}else{
			const params = new Proxy(new URLSearchParams(window.location.search), {
			    get: (searchParams, prop) => searchParams.get(prop),
			});
			if(params.t!=null && params.s!=null){
				var app_token = localStorage.getItem("app_token");
				var check_id = localStorage.getItem("erp_id");
				if(params.t != app_token || check_id!=params.s){
					let token = params.t;
					let erp_id = params.s;
					var app = {token:token,erp_id:erp_id}
					var new_id = erp_id.split('_');
					getKCISData('auth/verify_token',app).then((result) => {
						let responseJson = result;
						if(responseJson){
							if(result['status'] == 200){
								localStorage.setItem('schoolData',JSON.stringify(responseJson));
								localStorage.setItem("app_token",params.t);
								var erp_id = result['data'][0]['erp_id'];
								var erp_type = erp_id.split('_');
								localStorage.setItem("erp_id",erp_id);
								localStorage.setItem("erp_type",erp_type[0]);
								window.location.reload(false);
							}
						}
					});
				}
			}
			var date = new Date().toLocaleString("en-US", {timeZone: "Asia/Kolkata"});
			const new_acad = (new Date().getFullYear())+'-'+ (new Date().getFullYear()+1);
			
			var storedArray = JSON.parse(localStorage.getItem("schoolData"))
			var permission = storedArray['data'][0]['permission'];
			var user_type = storedArray['data'][0]['type'];
			setTimeout(() => {
				this.setState({ 
					user_id : storedArray['data'][0]['user_id'],
					school_id : storedArray['data'][0]['school_id'],
					permission : permission,
					user_type : user_type,
					academic_year : new_acad,
				});
			}, 50);
		}
		/*
		var user_id = storedArray['data'][0]['user_id'];
		var school_id = storedArray['data'][0]['school_id'];
		var type = storedArray['data'][0]['type'];
		var app = {user_id : user_id,school_id:school_id,type:type}
		getData('auth/get_login_token',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
					var aToken= result['data'];
					localStorage.setItem("aToken",aToken);
					var main_link = 'https://erp.kidzonia.co.in/panel/admin';
					var dayplan_link = 'https://erp.kidzonia.co.in/panel/dayplan';
					this.setState({
						main_link: main_link,
						dayplan_link: dayplan_link,
						aToken:aToken
					});
				}
				else{
					var aToken='null';
					localStorage.setItem("aToken",aToken);
					var main_link = 'https://erp.kidzonia.co.in/panel/admin';
					var dayplan_link = 'https://erp.kidzonia.co.in/panel/dayplan';
					this.setState({
						main_link: main_link,
						dayplan_link: dayplan_link,
						aToken:aToken
					});
				}
			}
		});
		*/
		setTimeout(() => {
			this.checkData();
		}, 500);
	}
	
	
	
	
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			this.setState({ user_id : storedArray['data'][0]['user_id'] });
			
			var school_id = storedArray['data'][0]['school_id'];
			var user_id = storedArray['data'][0]['user_id'];
			var app = {school_id:school_id,user_id:user_id}
			getData('GraphApi/class_wise_fees_tracker',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							graph_data: result['data'],
							mobile_data: result['mobile_data'],
							total_school: result['total_school'],
							//graph_data: result['data'][0]['graph_data'],
						});
					}else{
						this.setState({
							graph_data: [],
							total_school: 0,
							//graph_data: [],
						});
					}
				}
			});
		}
    }
	
	
	

	render()

	{
	const {aToken}=this.state;
	const isMobile = window.innerWidth <= 767;
	const options = {
	  plugins: {
		title: {
		  display: true,
		  text: 'Chart.js Bar Chart - Stacked',
		},
	  },
	  responsive: true,
	  scales: {
		y: {
		  stacked: true,
		},
		x: {
		  stacked: true,
		},
	  },
	};
	
	
					
		return (
			<>
				
				
				<div class="row bred">
					<div class="col-md-12">
						<div class="card ">
							<div class="card-body ">
								<h4 class="page-title"> 
									<i class="mdi mdi-apple-keyboard-command title_icon"></i> Class Wise Fees 1
									<div class="breadcrumb-wrapper">
										<ol class="breadcrumb">
											<li class="breadcrumb-item">
												<a href={`${process.env.PUBLIC_URL}/`} class="router-link-active" target="_self">
												<img src="https://erp.kidzonia.co.in/panel/assets/icons/home.png" className="home-img"/>
												</a>
											</li>
											<li class="breadcrumb-item"> Class Wise Fees</li>
										</ol>
									</div>
								</h4>
							</div>
						</div>
					</div>
				</div>
				
                <div class="">
                  <div class="row">
                     <div class="col-lg-12 mb-3 graph-d">
						<div class="row">
						<div class="col-md-12">
							<div class="student-fees-border">
								<div class="col-md-12">
									<span class="title">Graph</span>
								</div>
								
								{this.state.total_school > 0 ? (<>
								
								{isMobile ? (<>
									<Bar data={this.state.mobile_data} options={options} height={isMobile ? "350" : "100vh"} />
									</>):(<>
									<Bar data={this.state.graph_data} options={options} height={isMobile ? "350" : "100vh"} />
								</>)}
								
								</>) :(<>
									<div class="row">
									<div class="col-md-12">
										<h5 class="center">Please Wait while Loading !! </h5>
									</div>
									</div>
								 
								</>)}
								
							</div>
							
						</div>
						
						</div>
                     </div>
                  </div>
               </div>
			   </>
		) 
	} 
}
export default Index;
